import { createTheme, ThemeProvider } from "@mui/material/styles";
import MetronomeApp from "./components/MetronomeApp";
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next'; // Importamos useTranslation

// Crear un tema personalizado
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2", // Azul
    },
    secondary: {
      main: "#f50057", // Rosa
    },
  },
});

const App = () => {
  const { t, i18n } = useTranslation(); // Usamos el hook para obtener las traducciones

  return (
    <ThemeProvider theme={theme}>
          <Helmet>
        <meta charset="UTF-8" />
        <html lang={i18n.language} />
        <title>{t('title')}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://tempo-track-generator.web.app/" />
        <meta name="application-name" content="Tempo Track Generator" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="description" content={t('description')} />
        <meta name="keywords" content={t('keywords')} />
        <meta name="author" content="AFRoda Developments" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content={i18n.language} />
        <meta name="google-adsense-account" content="ca-pub-7980228488816164" />
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={t('og_title')} />
        <meta property="og:description" content={t('og_description')} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://i.imgur.com/FBo8jSU.jpg" />
        <meta property="og:url" content="https://tempo-track-generator.web.app/" />
        <meta property="og:site_name" content={t('title')} />
        <meta property="og:image:alt" content={t('og_title')} />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('og_title')} />
        <meta name="twitter:description" content={t('og_description')} />
        <meta name="twitter:image" content="https://i.imgur.com/FBo8jSU.jpg" />
        <meta name="twitter:creator" content="@afroda.development" />
      </Helmet>
      <MetronomeApp />
    </ThemeProvider>
  );
};

export default App;